import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Link, useParams, useLocation, Routes } from 'react-router-dom';
import { PrivateRoute } from '../components/PrivateRoute';
import { fetchBookDetail, toggleWishBook } from './ducks/bookInfo';
import BookDescription from './components/BookDescription';
import BookQuiz from './BookQuiz';
import ErrorMessageBox from '../components/ErrorMessageBox';
import VideoForm from '../videoreport/VideoForm';
import { Loading } from '../components/Loading';

import { BookReportForm } from '../bookreport/BookReportForm';
import { ReadingPictureForm } from '../readingPicture/ReadingPictureForm';
import { ReadingPhotoForm } from '../readingPhoto/ReadingPhotoForm';
import { BookDebateList } from 'app/debate/BookDebateList';
import { BookReportList } from 'app/bookreport/BookReportList';
import { ReadingPictureList } from 'app/readingPicture/ReadingPictureList';
import { VideoList } from 'app/videoreport/VideoList';
import sanitizeHtml from 'sanitize-html';
import { sanitizeOption } from 'lib/sanitizeHtml';

const BookView = () => {
    const { school, isbn } = useParams();
    const [lnbCode, setLnbCode] = useState("");
    const location = useLocation();
    const pathname = useMemo(() => location.pathname, [location]);
    const auth = useSelector(state => state.auth);
    const detailBook = useSelector(state => state.detailBook);
    const dispatch = useDispatch();


    useEffect(() => {
        const lnbSegment = pathname.split('/')[4];
        if (lnbCode !== lnbSegment) {
            setLnbCode(lnbSegment);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    useEffect(() => {
        dispatch(fetchBookDetail(isbn));
    }, [dispatch, isbn]);


    function onClickWishToggle() {
        if (!auth.authenticated) return null;
        dispatch(toggleWishBook(isbn));
    }

    // 키워드 화면
    function renderKeyword() {
        if (undefined === detailBook.book.keywords) return;

        return detailBook.book.keywords.map((keyword, key) => {
            return (
                <li key={key}>
                    <Link className={`tag ${keyword.keypoint === 'Y' ? 'main_tag' : ''}`} to={`/${school}/book?search_keyword=${encodeURIComponent("#" + keyword.name)}`}>
                        #{keyword.name}
                    </Link>
                </li>
            );
        });
    }

    //도서정보
    function renderBookInfo() {
        return (
            <div className={`book_detail_area service_${detailBook.book?.isService.toLowerCase()}`}>
                <div className="inner clear">
                    <div className="book_detail_wrap p-tb-8 grid-row-8">
                        <div className="book_cover_wrap col-1 col-lg-8">
                            <div className="book_cover">
                                <div className="book_inner">
                                    <img src={(null !== detailBook.book?.image && detailBook.book?.image.startsWith('http://')) ? `${detailBook.book?.image}` : detailBook.book?.image} alt={detailBook.book.title + ' 책표지'} />
                                    <div className={`service service_${detailBook.book.isService.toLowerCase()}`}></div>
                                    {detailBook.book.isService === 'Y' && detailBook.book.student_workbook === 'Y' && <div className="workbook student"></div>}
                                    {detailBook.book.isService === 'Y' && detailBook.book.teacher_workbook === 'Y' && <div className="workbook teacher"></div>}
                                </div>
                            </div>
                            {(detailBook.book.ebookLink !== null && detailBook.book.ebookLink !== '') && (
                                <a href={detailBook.book.ebookLink} target="_blank" title="새창" className="btn _xsm _blue" rel="noopener noreferrer"  >
                                    <i className="fa-solid fa-tablet-screen-button"></i> 전자책
                                </a>
                            )}
                        </div>
                        <div className="detail grid-row col-7 col-lg-8">
                            <div className="col-7 col-xl-12">
                                <div className="book_info">
                                    <strong className="title fs-18">{detailBook.book.title}</strong>
                                    <p className="info fs-16"><span className="name fc-main-color">{detailBook.book.author}</span><span className="pb_company">{detailBook.book.publisher}</span></p>
                                    <div className="keyword-list _mobile">
                                        {renderKeyword()}
                                    </div>
                                </div>
                                <div className="book_desc bg-white round p-tb-2 p-lr-3">
                                    <p dangerouslySetInnerHTML={{ __html: sanitizeHtml(detailBook.book.book_desc), sanitizeOption }} ></p>
                                </div>
                                <ul className="keyword-list _pc">
                                    {renderKeyword()}
                                </ul>
                            </div>
                            <div className="reading_activity col-5 col-xl-12">
                                <ul>
                                    <li>
                                        <Link className={`btn _sm ${(detailBook.book.isService !== 'Y' || !auth.authenticated) ? '_disabled' : ''}`} to={`/${school}/book/${isbn}/quiz`}>
                                            <i className="fa-solid fa-circle-question"></i>독서퀴즈 <span className={`apple ${detailBook.appleCheck?.appleQuiz ? '_on' : '_off'}`}></span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className={`btn _sm ${!auth.authenticated ? '_disabled' : ''}`} to={`/${school}/book/${isbn}/bookreport/create`}>
                                            <i className="fa-solid fa-pencil"></i>독서감상문 <span className={`apple ${detailBook.appleCheck.appleReport ? '_on' : '_off'}`}></span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className={`btn _sm ${!auth.authenticated ? '_disabled' : ''}`} to={`/${school}/book/${isbn}/picture/create`}>
                                            <i className="fa-solid fa-paintbrush"></i>독서화 <span className={`apple ${detailBook.appleCheck.applePicture ? '_on' : '_off'}`}></span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className={`btn _sm ${!auth.authenticated ? '_disabled' : ''}`} to={`/${school}/book/${isbn}/photo/create`}>
                                            <i className="fa-solid fa-camera"></i>독서사진 <span className={`apple ${detailBook.appleCheck.applePhoto ? '_on' : '_off'}`}></span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className={`btn _sm ${!auth.authenticated ? '_disabled' : ''}`} to={`/${school}/book/${isbn}/video/create`} >
                                            <i className="fa-solid fa-circle-play"></i>독서영상 <span className={`apple ${detailBook.appleCheck.appleYoutube ? '_on' : '_off'}`}></span> <span className={`apple second_apple ${detailBook.appleCheck.appleYoutube ? '_on' : '_off'}`}></span>
                                        </Link>
                                    </li>
                                    <li>
                                        <button className={`btn _sm _white _wish  ${!auth.authenticated ? '_disabled' : ''} ${(detailBook.wishBook) ? '_on' : ''}`} onClick={onClickWishToggle}>
                                            <i className="fa-regular fa-heart"></i>관심도서
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }



    if (detailBook.loading === true) return <Loading />;
    if (null !== detailBook.message) return <ErrorMessageBox message={detailBook.message} />;


    return (
        <div className="subpage" >
            <div id="contents" className="book book_intro">
                {renderBookInfo()}

                <div id="lnb">
                    <div className="inner">
                        <ul className="menu_list clear">
                            <li className={`${undefined === lnbCode || lnbCode === '' ? 'on' : ''} `}>
                                <Link to={`/${school}/book/${isbn}`}>도서소개</Link>
                            </li>
                            <li className={`${lnbCode === 'debate' ? 'on' : ''} `}>
                                <Link to={`/${school}/book/${isbn}/debate`}> 독서토론 <span>{detailBook.activityCount.debateCount}</span></Link>
                            </li>
                            <li className={`${lnbCode === 'bookreport' ? 'on' : ''} `}>
                                <Link to={`/${school}/book/${isbn}/bookreport`}> 독서감상문<span>{detailBook.activityCount.bookReportCount}</span></Link>
                            </li>
                            <li className={`${lnbCode === 'picture' ? 'on' : ''} `}>
                                <Link to={`/${school}/book/${isbn}/picture`}>독서화<span>{detailBook.activityCount.readingPictureCount}</span></Link>
                            </li>
                            <li className={`${lnbCode === 'photo' ? 'on' : ''} `}>
                                <Link to={`/${school}/book/${isbn}/photo`}>독서사진<span>{detailBook.activityCount.readingPhotoCount}</span></Link>
                            </li>
                            <li className={`${lnbCode === 'video' ? 'on' : ''} `}>
                                <Link to={`/${school}/book/${isbn}/video`}>독서영상<span>{detailBook.activityCount.youtubeCount}</span></Link>
                            </li>
                        </ul>
                    </div>
                </div>


                <Routes>
                    <Route path="/" element={<BookDescription />} />
                    <Route path="/quiz/*" element={<BookQuiz />} />

                    <Route path="/debate/*" element={<BookDebateList />} />

                    <Route path="/bookreport/create" element={<PrivateRoute><BookReportForm /></PrivateRoute>} />
                    <Route path="/bookreport/*" element={<BookReportList path={`/${school}/book/${isbn}/bookreport`} forcedData={{ isbn }} />} />


                    <Route path="/picture" element={<ReadingPictureList path={`/${school}/book/${isbn}/picture`} forcedData={{ isbn, type: 'picture' }} />} />
                    <Route path="/picture/create" element={<PrivateRoute><ReadingPictureForm /></PrivateRoute>} />

                    <Route path="/photo" element={<ReadingPictureList path={`/${school}/book/${isbn}/photo`} forcedData={{ isbn, type: 'photo' }} />} />
                    <Route path="/photo/create" element={<PrivateRoute><ReadingPhotoForm /></PrivateRoute>} />

                    <Route path="/video" element={<VideoList path={`/${school}/book/${isbn}/video`} forcedData={{ isbn }} />} />
                    <Route path="/video/create" element={<PrivateRoute><VideoForm /></PrivateRoute>} />
                </Routes>
            </div>
        </div>
    );
}//end BookView
export default BookView;